import { render } from "./teaTrainMenu.vue?vue&type=template&id=b13a0606&scoped=true"
import script from "./teaTrainMenu.vue?vue&type=script&lang=js"
export * from "./teaTrainMenu.vue?vue&type=script&lang=js"

import "./teaTrainMenu.vue?vue&type=style&index=0&id=b13a0606&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b13a0606"]])

export default __exports__